import { useContext, useEffect, useState } from "react";
import { EncabezadoCuentaCorriente } from "./components/EncabezadoCuentaCorriente";
import { AdminContext } from "../context/AdminContext";
import Modalcuenta from "./components/Modalcuenta";
import { styles, UserContainer, StyledFloatingButton, ProductoFiltroContainer, } from "./components/cuentasComponents";
import Card from "../components/Card/Card";
import CardHeader from "../components/Card/CardHeader";
import CardBody from "../components/Card/CardBody.js";
import { makeStyles } from "@mui/styles";
import Fab from "@mui/material/Fab";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "../components/generics/tabPanels";
import GenericStyledTable from "../components/generics/GenericStyledTable";
import { Autocomplete, Button, TextField } from "@mui/material";
import { UserContext } from "../context/UserContext.jsx";
import { getTimestampWithOffsetFromDate } from "../extras/utils.js";
import { obtenerDatosParaCuentaCorriente, obtenerExcelCuentaCorriente } from "../services/CuentasCorrientesService.js";
import XLSX from 'xlsx'
import { CircleLoader } from "react-spinners";

const useStyles = makeStyles(styles);

function Cuentas() {
  const classes = useStyles();

  const { selectedUser } = useContext(AdminContext);
  const { users, getUsers } = useContext(UserContext)

  // States
  const [modal, setModal] = useState(false);
  const [userSearchInput, setUserSearchInput] = useState('');
  const [userSelection, setUserSelection] = useState(null);
  const [dateFrom, setDateFrom] = useState(0);
  const [dateTo, setDateTo] = useState(0);
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [accountData, setAccountData] = useState({
    saldoCredito: 0,
    saldoEfectivo: 0,
    saldoNotaCredito: 0,
    notasCreditoUsadas: 0,
    pagadoConNotaCredito: 0,
    ventas: [],
    encabezadoVentas: {
      total: 0,
      ganancia: 0
    },
    comprasORetiros: [],
    encabezadocomprasORetiros: {
      gasto: 0,
      total: 0
    },
    devoluciones: [],
    encabezadoDevoluciones: {
      total: 0,
      montoDescontado: 0
    },
    encabezadoStock: {
      cantidad: 0,
      total: 0,
    },
    pedidosTotales: [],
    notasDeCredito: [],
    pagosConNotasDeCredito: []
  });

  //tabs
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function obtenerDatos(identificador) {
    if (!identificador) {
      setAccountData({
        saldoCredito: 0,
        saldoEfectivo: 0,
        saldoNotaCredito: 0,
        notasCreditoUsadas: 0,
        pagadoConNotaCredito: 0,
        ventas: [],
        encabezadoVentas: {
          total: 0,
          ganancia: 0
        },
        comprasORetiros: [],
        encabezadocomprasORetiros: {
          gasto: 0,
          total: 0
        },
        devoluciones: [],
        encabezadoDevoluciones: {
          total: 0,
          montoDescontado: 0
        },
        encabezadoStock: {
          cantidad: 0,
          total: 0,
        },
        pedidosTotales: [],
        notasDeCredito: [],
        pagosConNotasDeCredito: []
      })
    } else {
      try {
        const result = await obtenerDatosParaCuentaCorriente(identificador, dateTo, dateFrom);
        if (result !== null) setAccountData(result);
      } catch (error) {
        console.log(error);
      }
    }
  }

  const transformJsonToExcel = async () => {
    setLoadingExcel(true);
    try {
      const datos = await obtenerExcelCuentaCorriente();
      const parsedBook = datos.map(account => {
        const finalUser = {
          "Nombre de la proveedora": account.nombreProveedora,
          "Codigo de la proveedora": account.UserId,
          "Opción": account.opcion,
          "Total de Articulos ingresados": account.productosIngresados,
          "Total de Articulos Vendidos": account.productosVendidos,
          "Total Ganancia Ventas": account.ganancia,
          "Devolución - Total": account.devoluciones,
          "Total Retiros/Compras": account.gastos,
          "Total Saldo a Cobrar": account.saldo,
          "Articulos en Stock": account.productosStock,
          "Total $ en Stock": account.totalStock,
          "saldo Nota de Credito": account.saldoNotaCredito
        }

        return finalUser;
      });

      const book = XLSX.utils.book_new();
      const sheet = XLSX.utils.json_to_sheet(parsedBook);
      XLSX.utils.book_append_sheet(book, sheet, 'Cuentas');
      XLSX.writeFile(book, 'cuentas.xlsx');

    } catch (error) {
      console.log("Error al obtener las cuentas")
    } finally {
      setLoadingExcel(false);
    }

  }

  function openModal() {
    if (!userSelection) {
      alert("Seleccione un Usuario antes de agregar un movimiento");
      return;
    }
    setModal(true);
  }

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (selectedUser) {
      const result = users.find(usr => usr.identificador === selectedUser.identificador);
      if (result) {
        setUserSelection(result);
        setUserSearchInput(result.nombreCompleto)
        obtenerDatos(result.identificador);
      }
    }
    return () => setUserSelection(null);

  }, [selectedUser?.identificador])

  async function closeModal() {
    setModal(false);
    obtenerDatos(userSelection.identificador);
  }

  return (
    <UserContainer>
      {userSelection ? (
        <Modalcuenta modal={modal} closeModal={closeModal} selectedUser={userSelection} />
      ) : null}
      <Card>
        <CardHeader color="success">
          <h2 className={classes.cardTitleWhite}>
            Cuentas Corrientes
            {userSelection ? ` de: ${userSelection.nombreCompleto} (${userSelection.identificador}) ${userSelection?.dni ? " DNI: " + userSelection?.dni : ""}` : null}
          </h2>
          <h2 className={classes.cardTitleWhite}>
            {userSelection ? `Preferencia: ${userSelection?.preferenciaPago}` : null}
          </h2>
          <p className={classes.cardCategoryWhite}>
            Visualizaras los movimiento de un usuario/proveedor
          </p>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "end" }}>
            <Button variant="contained" onClick={transformJsonToExcel} color="success">{loadingExcel ? <CircleLoader loading={loadingExcel} /> : "Descargar Excel"}</Button>
          </div>
        </CardHeader>
        <CardBody>
          {
            /*  -----------------------------------------------------------------------------------------------------
                 -----------------------------------------------ENCABEZADOS-----------------------------------------------
                 -----------------------------------------------------------------------------------------------------*/
          }
          <EncabezadoCuentaCorriente accountData={accountData} userSelection={userSelection} />
          {
            /*  -----------------------------------------------------------------------------------------------------
                 -----------------------------------------------FILTROS-----------------------------------------------
                 -----------------------------------------------------------------------------------------------------*/
          }
          <ProductoFiltroContainer>
            <Autocomplete
              id='combo-box-demo'
              options={users}
              isOptionEqualToValue={(option, value) => option._id === value._id}
              getOptionLabel={option => option.nombreCompleto}
              inputValue={userSearchInput}
              onInputChange={(_, newInputValue) => {
                setUserSearchInput(newInputValue);
              }}
              onChange={(_, value, reason) => {
                if (reason === "selectOption") {
                  setUserSelection(value);
                  obtenerDatos(value.identificador);
                }
                else {
                  setUserSelection(null);
                  obtenerDatos(null);
                }
              }}
              renderOption={(props, option) => {
                return <li {...props} key={option._id}>{option.nombreCompleto}</li>
              }}
              renderInput={params => <TextField {...params} label='Elija un proveedor' variant='outlined' />}
            />
          </ProductoFiltroContainer>
          <ProductoFiltroContainer>
            <TextField
              variant='outlined'
              id='date'
              label='desde'
              type='date'
              value={dateFrom}
              onChange={e => {
                setDateFrom(new Date(getTimestampWithOffsetFromDate(e.target.value)).toISOString().split("T")[0]);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              variant='outlined'
              id='date'
              label='hasta'
              type='date'
              inputProps={{
                min: dateFrom,
              }}
              value={dateTo}
              onChange={e => {
                setDateTo(new Date(getTimestampWithOffsetFromDate(e.target.value)).toISOString().split("T")[0]);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </ProductoFiltroContainer>
          <Paper square>
            <Tabs
              value={value}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleChange}
              aria-label="disabled tabs example"
            >
              <Tab label="Ventas" />
              <Tab label="Compras" />
              <Tab label="Devoluciones" />
              <Tab label="Retiros" />
              <Tab label=" Pago con nota de credito" />
              <Tab label="Saldos/Nc generados" />
              <Tab label="Pedidos" />
            </Tabs>
          </Paper>
          <>
            <TabPanel value={value} index={0}>
              <GenericStyledTable column="venta" dataset={accountData.ventas} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <GenericStyledTable column="compra" dataset={accountData.comprasORetiros.filter(mov => mov.tipoMovimiento === "VENTA")} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <GenericStyledTable
                column="devolucion"
                dataset={accountData.devoluciones}
              />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <GenericStyledTable column="otros" dataset={accountData.comprasORetiros.filter(mov => mov.tipoMovimiento === "RETIRAR")} />
            </TabPanel>
            <TabPanel value={value} index={4}>
              <GenericStyledTable column="otros" dataset={accountData.pagosConNotasDeCredito} />
            </TabPanel>
            <TabPanel value={value} index={5}>
              <GenericStyledTable column="otros" dataset={accountData.notasDeCredito} />
            </TabPanel>
            <TabPanel value={value} index={6}>
              <GenericStyledTable column="pedidos" dataset={accountData.pedidosTotales} />
            </TabPanel>
          </>
        </CardBody>
      </Card>
      <StyledFloatingButton>
        <Fab color="secondary" aria-label="add" onClick={openModal}>
          +
        </Fab>
      </StyledFloatingButton>
    </UserContainer>
  );
}

export default Cuentas;
